import {URL_BASE_API } from '../../../configs/urlConfigs';

import service from '../../api';

export const subSectorList = (request) => {
    let ENDPOINT = '';
    if(request.data!==undefined){      
      let column = request.data.column;     
      if(column){
        ENDPOINT = URL_BASE_API+'super-admin/subsector/?column='+column;
      }
    }else{
        ENDPOINT = URL_BASE_API+'super-admin/subsector/';
    }   

    return service.get(ENDPOINT);
    
};

export const subSectorAllList = (request) => {
  const ENDPOINT = URL_BASE_API+'super-admin/subsectorlist/';

  return service.get(ENDPOINT);
  
};


export const subSectorAdd = (request) => {
  const ENDPOINT = URL_BASE_API+'super-admin/subsector/';

  return service.post(ENDPOINT,request.data);
  
};

export const subSectorEdit = (request) => {
  let subSectorId = request.data;
  const ENDPOINT = URL_BASE_API+'super-admin/subsector/'+subSectorId;

  return service.get(ENDPOINT);  
  
};


export const subSectorUpdate = (request) => {
  let subSectorId = request.data.id;
  const ENDPOINT = URL_BASE_API+'super-admin/subsector/'+subSectorId;

  return service.put(ENDPOINT,request.data);  
  
};

export const subSectorDelete = (request) => {
  const ENDPOINT = URL_BASE_API+'super-admin/subsector/'+request.data;
  return service.delete(ENDPOINT);   
};  